export const meta = {
  title: '收银(POS):从待取车到已付款,一次点击',
  updatedAt: '2026-07-17',
  related: ['queue-board', 'loyalty', 'catalog'],
};

**收银(POS)**页面是洗车单的终点。它列出当前门店所有*待取车*的单子,最早的排最前,顶部有实时数量。点开一张单子,付款单随即展开,带完整的价格明细。

## 确认付款

付款单显示小计、每笔折扣单独一行——促销、等级折扣、代金券——以及最终总额。选好顾客的付款方式,点**确认**。这一下同时记录付款*并*完成取车:单子归档进历史,会员积分即时到账,队伍就此了结这张单。

## 付款方式

付款单上的选项芯片共八种:**现金**、**DuitNow QR**、**TNG**、**GrabPay**、**银行卡**、**银行转账**、**代金券**、**免单**。现金是预选项,因为它仍是柜台常态。付款方式会记录在案,报表能分清扫码日和现金日。

## 折扣自己找上门

- 您设置的**促销**(欢乐时光、指定星期优惠)在顾客下单时就附着在单子上,以只读的优惠行显示。收银员不能移除或修改——顾客下单时被承诺了那个价格,POS 负责兑现承诺。
- **等级折扣**对会员顾客自动生效——以默认等级阶梯为例,白银 5%、黄金 10%。
- **代金券**是唯一由收银员操作的折扣:付款单列出该顾客自己的有效代金券,做成可点选的芯片。选中要用的——每张单独占一行减项——付款确认那一刻才标记已用,不提前、不重复。没有码要输。没有顾客账号的散客单,自然没有代金券可选。

## 付款前加购

顾客在柜台答应加个打蜡?点付款单上的**+ 为这张单添加项目**。凡是对该单车型有定价的加购项都能加上,总额即时更新,促销同步重算——一个加购把单子推过满减门槛,折扣当场触发。已在单上的项目、或没有该车型定价的项目,会显示为不可选,而不是无声地失败。

加购严格限于**付款前**。单子一旦付款——或顾客正在应用里付款——修改会被拒绝。

## 顾客应用里已付款的单子

顾客已在线上结清的单子挂着绿色的**已在线支付**标记。POS 不允许任何人再收一次钱——剩下唯一的操作是交车时点**标记已取车**。

## 预付洗车包

如果顾客持有覆盖本次洗车的有效预付洗车包,付款单会给出**核销 1 次洗车**——一次点击从包里扣一次,单子以 RM 0 结清。洗车包余量即时更新。

## POS 还做不到的

坦白角:没有分单支付(一张单一种方式)、没有找零计算器、没有退款按钮——收错了钱,目前的做法是先结掉再开一张新单。打印或邮件小票也尚未构建;每笔付款都连同完整明细存档,日后加上小票功能不会丢失任何历史。
